import { IconContent } from '@icons';

export const arrowsOut: IconContent = {
    sm: '<path d="m12.303 2.797.331-.093-4.3 4.3.662.662 4.3-4.3-.093.331a3.743 3.743 0 0 0-.139 1.01v3.054H14V2H8.239v.936h3.054c.341 0 .681-.047 1.01-.14ZM3.697 13.203l-.331.093 4.3-4.3-.662-.662-4.3 4.3.093-.33c.092-.33.139-.67.139-1.011V8.239H2V14h5.761v-.936H4.707c-.341 0-.681.047-1.01.14Z" />',
    md: '<path d="M12.5 6h4.793l-4.647 4.646.708.708L18 6.707V11.5h1V5h-6.5v1Zm-1 12H6.707l4.647-4.646-.708-.708L6 17.293V12.5H5V19h6.5v-1Z" />',
};
